import React from "react";
import "./header-footer.css";

import "bootstrap/dist/css/bootstrap.min.css";

import { Row, Col, Container, NavItem, NavLink, Nav } from "reactstrap";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";

function Footer({ footeremail, footernum, toggleMenu, togglefeedback }) {
  const openlink = (link) => {
    window.open(link, "_blank");
  };
  return (
    <>
      <div
        className="footer-main"
        onClick={() => {
          toggleMenu();
        }}
      >
        <Container>
          <Row>
            <Col md="4" className="mb-5 footer-col1">
              <div className="mb-4 footer-logo">
                <img
                  src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/logo.png"
                  alt=""
                />
              </div>
              <p className="footer-col1-desp">
                Powerful Dream Analysis Created to Translate your Subconscious
                to your Conscious Mind and Awaken Your Potential.
              </p>
            </Col>
            <Col md="5" className="mb-5 footer-col2">
              <h4>Quick Links</h4>

              <Row>
                <Col md="6" className="col-6">
                  <Nav vertical>
                    <NavItem>
                      <NavLink href="#">About us</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="#">Resources</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/faq">FAQs / Videos</NavLink>
                    </NavItem>
                  </Nav>
                </Col>
                <Col md="6" className="col-6">
                  <Nav vertical>
                    <NavItem>
                      <NavLink href="/auth/additionalDetails">
                        Your Account
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="https://seventhsight.com/blog/"
                        target="_blank"
                      >
                        Dream Blog
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/contactus">Contact us</NavLink>
                    </NavItem>
                    {/* <NavItem className="pointer" onClick={togglefeedback}>
											<NavLink>Contact Us</NavLink>
										</NavItem> */}
                  </Nav>
                </Col>
              </Row>
            </Col>

            <Col md="3" className="mb-5 footer-contact footer-col3">
              <p className="underline-text seventh-site-underline-text">
                Contact Us
              </p>
              <div className=" links ">
                <div className="contact-us about-us ">
                  <div className="info seventh-site-footer-info">
                    <LocalPhoneOutlinedIcon className="prmiary-color" />
                    <a href="tel:+9153548924">{footernum}</a>
                  </div>
                  <div className="info seventh-site-footer-info">
                    <MailOutlineOutlinedIcon className="prmiary-color" />
                    <a href="mailto:info@gmail.com">{footeremail}</a>
                  </div>
                  <div className="flexRowStart w-100  cg-1">
                    <img
                      className="icon-48 pointer"
                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/facebook.png?t=2024-01-09T18%3A11%3A44.244Z"
                      alt="icon"
                      onClick={() =>
                        openlink("https://www.facebook.com/SeventhSightAi/")
                      }
                    />
                    <img
                      className="icon-48 pointer"
                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/twitter.png?t=2024-01-10T08%3A26%3A05.484Z"
                      alt="icon"
                      onClick={() =>
                        openlink("https://www.Twitter.com/seventhsightai/")
                      }
                    />
                    <img
                      className="icon-48 pointer"
                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/instagram.png?t=2024-01-10T06%3A26%3A52.342Z"
                      alt="icon"
                      onClick={() =>
                        openlink("https://www.instagram.com/seventhsightai/")
                      }
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="footer-mb-reverse">
            <Col md="6" className="footer-copy text-left">
              &copy; SeventhSIGHT - All Rights Reserved
            </Col>
            <Col md="6" className="footer-copy-menu">
              <a href="/data-subject">Data Subject Access Request</a>{" "}
              <a href="/terms-conditions">Terms & Conditions</a>{" "}
              <a href="/privacy-policy">Privacy Policy</a>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Footer;
